import React, { useEffect } from 'react';
import { CertificateTemplateDetailWrapper } from '@components';
import { scrollTop } from '@share/utils';
import styles from './styles.module.scss';

export const CertificateTemplateDetailPage = (): React.ReactElement => {
  useEffect(() => {
    scrollTop();
  }, []);

  return (
    <div className={styles.root}>
      <CertificateTemplateDetailWrapper />
    </div>
  );
};
